import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class ParametreService {
	constructor(private http: HttpClient) { }

	statut(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:status',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	state(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:state',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	statut_group(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:statut_group',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	type(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:type',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	courrier(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:courrier',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	suivi(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:suivi',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	fichier(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:fichier',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	zonestype(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:zonestype',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	zones(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:zones',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	page(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:page',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	demande(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:demande',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	instructionstatut(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:instructionstatut',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	instruction(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:instruction',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	contact(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.parametre:contact',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
